import { interpolate } from 'remotion';
import { getEasingFunction } from './utils';
import { SegmentTransitionType } from '@/App/remotion/MainPlayer/types/Track/SegmentTransition';
import type { SegmentTransitionDefinition } from '@/App/remotion/libs/transitions/segmentTransition/types';

export const SEGMENT_TRANSITION_REGISTRY: Record<SegmentTransitionType, SegmentTransitionDefinition> = {
  [SegmentTransitionType.FADE]: {
    id: SegmentTransitionType.FADE,
    renderStrategy: 'non_overlap',

    getStyles: ({ currentFrame, segmentDurationInFrames, transition, side }) => {
      const { outDurationInFrames, inDurationInFrames, properties } = transition;
      const easing = getEasingFunction(properties?.easing);

      if (side === 'out') {
        const fadeOutStart = segmentDurationInFrames - (outDurationInFrames || 0);
        if (currentFrame < fadeOutStart) {
          return { contentOpacity: 1, overlayOpacity: 0 };
        }

        const progress = interpolate(currentFrame, [fadeOutStart, segmentDurationInFrames], [0, 1], {
          easing,
          extrapolateLeft: 'clamp',
          extrapolateRight: 'clamp'
        });

        return {
          overlayOpacity: progress,
          contentOpacity: 1 - progress
        };
      }

      const fadeInEnd = inDurationInFrames || 0;
      if (currentFrame >= fadeInEnd) {
        return { contentOpacity: 1, overlayOpacity: 0 };
      }

      const progress = interpolate(currentFrame, [0, fadeInEnd], [1, 0], {
        easing,
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });

      return {
        overlayOpacity: progress,
        contentOpacity: 1 - progress
      };
    }
  }
};

export const getSegmentTransitionDefinition = (
  transitionType: SegmentTransitionType
): SegmentTransitionDefinition | undefined => {
  return SEGMENT_TRANSITION_REGISTRY[transitionType];
};
